import { MedalCardFragmentFragment } from '@/__generated__/graphql.ts';
import { MedalAvatar } from '@/components/medal-avatar/medal-avatar.tsx';
import { MoneyBadge } from '@/components/tournaments/money-badge.tsx';
import {
  tournamentMedalContainer,
  tournamentMedalHeader,
  tournamentMedalRewardItem,
  tournamentMedalRewardsContainer,
} from '@/routes/_app.p.tournaments_.$id/tournament-medal/tournament-medal.css.ts';
import { formatYearsMonthsWeeksDays } from '@/utils/format-years-months-weeks-days.ts';

type TournamentMedalProps = {
  medal: MedalCardFragmentFragment;
};
export const TournamentMedal: React.FC<TournamentMedalProps> = ({ medal }) => {
  return (
    <div className={tournamentMedalContainer}>
      <div className={tournamentMedalHeader}>
        <MedalAvatar width={32} height={32} s3Key={medal.image?.key} />
        <span>{medal.name}</span>
      </div>
      {medal.money ? (
        <MoneyBadge text={`US ${medal.money.toString()}`} />
      ) : null}
      <div className={tournamentMedalRewardsContainer}>
        <div className={tournamentMedalRewardItem}>
          Vote power: +{medal.votePowerReward}
          {medal.durationDays
            ? ` (for ${formatYearsMonthsWeeksDays(medal.durationDays)})`
            : null}
        </div>
        <div className={tournamentMedalRewardItem}>
          Upvotes: +{medal.upvotesReward}
        </div>
      </div>
    </div>
  );
};
